import { isRejectedWithValue } from '@reduxjs/toolkit'

import { disconnect } from 'store/reducers-common/Auth/slice'

import type { Middleware } from '@reduxjs/toolkit'

import { shouldExpireSessionForEndpoint } from './sessionExpiration'

export const sessionExpiredMiddleware: Middleware = (api) => (next) => (action) => {
  if (
    isRejectedWithValue(action) &&
    action.payload?.status === 401 &&
    shouldExpireSessionForEndpoint(action.meta?.arg?.endpointName)
  ) {
    api.dispatch(disconnect())
  }

  return next(action)
}
